const SmallImages = {
  sunflowerSeeds: require("../Images/sunflower-seeds-2.jpg").default,
  appleSmall: require("../Images/appleSmall.jpg").default,
  cashewsSmall: require("../Images/cashewsSmall.jpg").default,
  mixedNutSmall: require("../Images/mixedNutSmall.jpg").default,
  oatSmall: require("../Images/oatSmall.jpg").default,
  strawberrieSmall: require("../Images/strawberrieSmall.jpg").default,
  flaxSeedSmall: require("../Images/flax-seeds-small.jpg").default,
  mangoeSmall: require("../Images/mangoeSmall.jpg").default,
  onionSmall: require("../Images/onionSmall.jpg").default,
  spinachSmall: require("../Images/spinachSmall.jpg").default,
  quinoaSmall: require("../Images/quinoaSmall.jpg").default,
};
export { SmallImages };
